import {useEffect, useState} from "react";
import axios from "axios";
import {getTokenService} from "./useTokenService";
import {settings} from "../config";

export const useBidData = ({user}: { user: any }) => {
    const [bidData, setBidData] = useState([])
    useEffect(() => {
        getData().then(() => {
        })
    }, []);
    const getData = async () => {
        let {token} = getTokenService({user: user})
        const {data} = await axios.get(settings.baseUrl + 'AdminBidList/GetBidHistory', {headers: {"Authorization": "Bearer " + token()}})
        setBidData(data)
        return data
    }
    return {
        bidData: bidData
    }
}